import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import VueFullPage from 'vue-fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'
//引入动画
import "animate.css";
import WOW from "wow.js";
import { createHead } from "@unhead/vue";
// 初始化 WOW.js
const wow = new WOW();
wow.init();

//seo unhead
const head = createHead();
createApp(App).use(store).use(router).use(ElementPlus).use(head).use(VueFullPage).mount("#app");
